import { curry, map, zipObj } from 'ramda';
import { viewTypeList } from '@components-common/types';

export const createViewId = (type: string, id: string) => `v.${id}.${type}`;
export const createViewIdObj = (type: string, id: string) => ({
  id: createViewId(type, id),
  type,
});

export const curriedCreateViewId = curry(createViewIdObj);
const createViewTypeObject = (viewTypes: ReadonlyArray<string>) => {
  const createViewIds = map((viewType) =>
    curriedCreateViewId(viewType as string)
  )(viewTypes);
  return zipObj(viewTypes, createViewIds);
};

export const buildId = createViewTypeObject(viewTypeList);
